import React from 'react'
import styled from 'styled-components'

/**
 * 汎用アイコンラッパー
 * 幅、高さ、色の指定機能付き
 */
const Icon: React.FC<IconProps> = (props) => {
  return <StyledIcon {...props} />
}

export type IconProps = {
  width?: string
  height?: string
  color?: string
  children?: React.ReactNode
}

export const StyledIcon = styled.i<{
  width?: string
  height?: string
  color?: string
}>`
  display: inline-flex;
  fill: ${(props): string => (props.color ? props.color : 'var(--color-main)')};
  &&& svg {
    ${(props): string => (props.width ? `width: ${props.width};` : '')};
    ${(props): string => (props.height ? `height: ${props.height};` : '')};
  }
`

export default Icon
